<template>
  <video controls="controls" class="hv">
    <source :src="src" :poster="poster" type="video/mp4" />
  </video>
</template>

<script>
export default {
  props: ['src', 'poster'],
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/variables';
@import '~@/assets/styles/breakpoints';

.hv {
  max-height: 485px;
  max-width: 865px;
  margin-bottom: 150px;
}

@media (max-width: $page-laptop-breakpoint) {
  .hv {
    max-height: auto;
    max-width: 700px;
    margin-bottom: 100px;
  }
}

@media (max-width: $page-table-breakpoint) {
  .hv {
    max-width: $page-mobile-large-breakpoint;
    padding: 0 10px;
  }
}

@media (max-width: $page-mobile-large-breakpoint) {
  .hv {
    max-width: $page-mobile-small-breakpoint;
  }
}
</style>
